<template>
  <PopupWrapper @close="$emit('close')">
    <h1>Quote request</h1>
    <hr />
    <div class="form">
      <div class="form-fields-stack">
        <div class="form-field col col-6">
          <label for="name">Name*</label>
          <input
            type="text"
            placeholder=""
            name="name"
            v-model="form.full_name"
            id="full_name"
            required
          />
          <span class="validate">{{ errors.full_name }}</span>
        </div>
        <div class="form-field col col-6">
          <label for="email">Email*</label>
          <input
            type="text"
            placeholder=""
            name="email"
            v-model="form.email"
            id="email"
            required
          />
          <span class="validate">{{ errors.email }}</span>
        </div>
      </div>
      <div class="form-fields-stack">
        <div class="form-field col col-6 subject">
          <label for="subject">Subject*</label>
          <input
            type="text"
            placeholder=""
            v-model="form.subject"
            name="subject"
            id="subject"
            required
          />
          <span class="validate">{{ errors.subject }}</span>
        </div>
      </div>
      <div class="form-field col col-12">
        <label for="message">Message*</label>

        <textarea
          type="text"
          placeholder=""
          name="message"
          v-model="form.message"
          required
          id="message"
        ></textarea>

        <span class="validate">{{ errors.message }}</span>
      </div>

      <div class="col buttons flex">
        <button class="button" type="submit" v-on:click="submitForm()">
          SUBMIT
        </button>
        <span>*Mandatory fields</span>
      </div>
    </div>
  </PopupWrapper>
</template>

<script>
import PopupWrapper from "@/components/Popups/Wrapper";

export default {
  components: { PopupWrapper },

  props: {
    request_id: Number,
  },
  data() {
    return {
      files: [],
      form: {
        full_name: "",
        email: "",
        subject: "",
        message: "",
      },
      errors: {
        full_name: null,
        email: null,
        subject: null,
        message: null,
      },
    };
  },

  methods: {
    /*
		Submits the file to the server
		*/
    submitForm() {
      /*
			Initialize the form data
			*/
      let formData = new FormData();

      /*
			Iteate over any file sent over appending the files
			to the form data.
			*/
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];
        formData.append("files[" + i + "]", file);
      }

      formData.append("full_name", this.form.full_name);
      formData.append("email", this.form.email);
      formData.append("subject", this.form.subject);
      formData.append("message", this.form.message);

      /*
			Make the request to the POST /multiple-files URL
			*/
      console.log(this.form);
      window.axios
        .post("/quote-now/" + this.request_id, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(($res) => {
          this.$store.commit("setToastMessage", {
            open: true,
            type: "success",
            message: "Quote form successfully submitted",
          });
          this.$emit("close");

        })
        .catch((error) => {
          this.errors.full_name = "";
          this.errors.email = "";
          this.errors.subject = "";
          this.errors.message = "";
          console.log(error);
          if (error.response.status == 422) {
            $.each(error.response.data.errors, (remote_key, remote_value) => {
              if (remote_key == "email") {
                this.errors.email = remote_value[0];
              }
              if (remote_key == "full_name") {
                this.errors.full_name = remote_value[0];
              }
              if (remote_key == "message") {
                this.errors.message = remote_value[0];
              }
              if (remote_key == "subject") {
                this.errors.subject = remote_value[0];
              }
            });
          }
        });
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Popups/QuoteRequest.vue